import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import {  getCurrencyApi } from "helpers/backend_helper";
import {errorMsg, successMsg} from "helpers/toastr";
 /**
      * Used for calling currency listing api
      */

function* getCurrencySaga({ payload }) {
  try {
    const response = yield call(getCurrencyApi, payload);
    if (response.status == "failure") {
      return yield put(ACT.getCurrencyFail(response.message));
    }
    yield put(ACT.getCurrencySuccess(response));
  } catch (error) {
    yield put(ACT.getCurrencyFail(error));
  }
}



function* currencySaga() {
  yield takeEvery(CONST.GET_CURRENCY, getCurrencySaga);
}

export default currencySaga;
